import enMessages from '../locales/en_US';

const enLang = {
  messages: {
    ...enMessages,
  },
  locale: 'en-US',
};

export default enLang;